/*! License details at fancyapps.com/license */
const s=(s,t="",c)=>{s&&s.classList&&t.split(" ").forEach((t=>{t&&s.classList.toggle(t,c||!1)}))};export{s as toggleClass};
